import { createContext } from 'react';

const noop = () => null;

export const initialRegistrationData = {
  email: '',
  password: '',
  password_repeat: '',
};

export const initialContextState = {
  user: undefined,
  signOut: noop,
  signIn: user => null,
  handleAuthError: error => null,
  registrationData: initialRegistrationData,
  setRegistrationData: data => null,
};

export const AuthContext = createContext(initialContextState);
